import React, { useState } from "react";

const FAQ_ITEMS = [
    { q: "What does this cost?", a: "Nothing. The brief is free, forever. We make money in two ways: paid sponsorships in some issues (always disclosed at the top), and partner referrals when readers ask to be connected with retirement specialists. We don't charge subscribers, and we never will." },
    { q: "How often will you email me?", a: "Once a month, the first Tuesday. That's the brief. Occasionally we send a one-off note if something genuinely time-sensitive happens (a major Fed move, a tax-law change). We won't send daily emails. We won't send \u201Calerts.\u201D We won't sell you anything in your inbox." },
    { q: "Is this financial advice?", a: "No. Brass Tacks Brief is journalism and analysis, not personalized financial advice. We're not a registered investment advisor. Nothing in the brief is a recommendation to buy, sell, or hold any specific investment. If you want personalized advice, talk to a fiduciary." },
    { q: "What happens with my phone number?", a: "When you subscribe, we'll connect you with a vetted retirement specialist for a free 15-minute call to answer your questions about long-term planning, hard-asset strategies, or whatever else you're working through. You're under no obligation. The call is part of how Brass Tacks Brief stays free for readers." },
    { q: "Will you share my information?", a: "Your email is never sold or rented. Your phone number is shared only with the one partner you've authorized to contact you at the moment of submission. That partner is named on the form before you submit. Full details are in our Privacy Policy." },
    { q: "Who's behind this?", a: "Brass Tacks Brief is published by Brass Tacks Research LLC, an independent publisher. We don't take money from Wall Street firms, brokerages, or asset managers. Our editorial views are our own." },
];

export default function Faq() {
    const [open, setOpen] = useState(() => new Set());
    const toggle = (i) => {
        setOpen((prev) => {
            const n = new Set(prev);
            if (n.has(i)) n.delete(i);
            else n.add(i);
            return n;
        });
    };

    return (
        <ul
            role="list"
            data-testid="faq-list"
            style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                borderTop: "1px solid var(--bt-ink)",
            }}
        >
            {FAQ_ITEMS.map((item, idx) => {
                const isOpen = open.has(idx);
                const panelId = `faq-panel-${idx}`;
                const btnId = `faq-trigger-${idx}`;
                return (
                    <li
                        key={idx}
                        style={{ borderBottom: "1px solid var(--bt-rule)" }}
                    >
                        <button
                            id={btnId}
                            type="button"
                            aria-expanded={isOpen}
                            aria-controls={panelId}
                            onClick={() => toggle(idx)}
                            data-testid={`faq-trigger-${idx}`}
                            className="bt-accordion-trigger"
                            style={{
                                width: "100%",
                                textAlign: "left",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 24,
                                padding: "26px 0",
                                background: "transparent",
                                border: 0,
                                cursor: "pointer",
                                fontFamily: "Fraunces, Newsreader, serif",
                                fontVariationSettings: '"opsz" 36, "SOFT" 0',
                                fontWeight: 500,
                                fontSize: 19,
                                lineHeight: 1.35,
                                letterSpacing: "-0.012em",
                                color: "var(--bt-ink)",
                            }}
                        >
                            <span>{item.q}</span>
                            <span
                                aria-hidden="true"
                                style={{
                                    color: "var(--bt-mute)",
                                    fontFamily: "Geist, sans-serif",
                                    fontSize: 18,
                                    fontWeight: 300,
                                    lineHeight: 1,
                                    flexShrink: 0,
                                    transition: "transform 220ms ease",
                                    transform: isOpen ? "rotate(45deg)" : "rotate(0deg)",
                                    display: "inline-block",
                                }}
                            >
                                +
                            </span>
                        </button>
                        <div
                            id={panelId}
                            role="region"
                            aria-labelledby={btnId}
                            data-testid={`faq-panel-${idx}`}
                            style={{
                                display: "grid",
                                gridTemplateRows: isOpen ? "1fr" : "0fr",
                                transition: "grid-template-rows 240ms ease-out",
                            }}
                        >
                            <div style={{ overflow: "hidden" }}>
                                <p
                                    className="t-body"
                                    style={{
                                        margin: 0,
                                        paddingBottom: 26,
                                        maxWidth: 620,
                                    }}
                                >
                                    {item.a}
                                </p>
                            </div>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
}
